import { DocType } from "./DocType";

export interface DocDesc {
  desc: string;
  docType: DocType;
}

export class DocDescs {
  private static DOC_DESCS: DocDesc[] = [
    {
      desc: `Upload the front and back side of your driver's license or state ID to verify your ID. Check out the
             example below for instructions.`,
      docType: DocType.LICENSE_FRONT_AND_BACK,
    },
    {
      desc: `Upload the front side of your driver's license or state ID to verify your ID. Check out the example
           below for instructions.`,
      docType: DocType.LICENSE_FRONT,
    },
    {
      desc: `Upload the back side of your driver's license or state ID to verify your ID. Check out the example
           below for instructions.`,
      docType: DocType.LICENSE_BACK,
    },
  ];

  public static getDocDesc(docType: DocType): DocDesc | undefined {
    return DocDescs.DOC_DESCS.find( (d) => d.docType === docType);
  }
}



// WEBPACK FOOTER //
// ./src/constants/DocDescs.ts